
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/api-clients",
      function () {
        return require("private-next-pages/api-clients/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/api-clients"])
      });
    }
  